import * as store from '@attain-apps/fe/web/main/lib/store'

import { State } from './state'
import type { Operation } from './types'

/**
 * Core actions for the survey status of a space lite record (sign off and unlock).
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Opens the confirmation dialog of the given operation */
    initiate: store.actions.standalone({
      data: store.actions.Data.asIs<{ operation: Operation }>(),
      reducer: ({ data: { operation } }) => ({ [operation]: {} }),
    }),
    /** Closes the confirmation dialog of the given operation */
    cancel: store.actions.standalone({
      data: store.actions.Data.asIs<{ operation: Operation }>(),
      reducer: () => State.INITIAL,
    }),
    /** Submits the confirmed operation for the current space lite record */
    submit: store.actions.request({
      input: store.actions.Data.asIs<{ operation: Operation }>(),
      output: store.actions.Data.NONE,
      reducers: {
        request: ({ data: { operation } }) => ({
          [operation]: { isSubmitting: true },
        }),
        success: () => State.INITIAL,
        error: ({ data: { error, request } }) => ({
          [request.operation]: { error },
        }),
        cancellation: ({ data: { request } }) => ({
          [request.operation]: {},
        }),
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
